<template>
  <div class="row">
    <div class="col-lg-12">
      <div ref="myChart" :style="{ width: 'auto', height: '300px' }"></div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";

export default {
  props: {
    lineDataX: {
      type: Array,
      default: () => [],
    },
    lineDataS: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
    type: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      chart: null,
    };
  },
  mounted() {
    this.drawLine();
  },
  watch: {
    lineDataS: function() {
      this.drawLine();
    },
  },
  methods: {
    exportData() {
      this.$emit("change", this.type);
    },
    drawLine() {
      let myChart;
      // 基于准备好的dom，初始化echarts实例
      if (this.chart) {
        myChart = this.chart;
      } else {
        this.chart = myChart = this.$echarts.init(this.$refs.myChart);
      }
      // 绘制图表
      let that = this;
      myChart.setOption({
        title: {
          text: this.title,
          subtext: "",
        },
        tooltip: {
          trigger: "axis",
        },
        xAxis: {
          type: "category",
          boundaryGap: false,
          data: this.lineDataX,
          axisTick: {
            show: false, // 隐藏坐标轴的刻度线
            alignWithLabel: true, // 图形于标题居中
            inside: true, // 刻度线是指向内部还是外部
            length: 0, // x轴上指向标题刻度线的长度
          },
          axisLabel: {
            // textStyle: {
            //   color: "rgba(0,0,0,.80)", // 坐标轴文字颜色
            //   fontSize: 10, // 坐标轴文字大小
            // },
            color: "rgba(0,0,0,.80)", // 坐标轴文字颜色
            fontSize: 10, // 坐标轴文字大小
          },
        },
        yAxis: {
          type: "value",
          axisLabel: {
            formatter: "{value}",
          },
        },
        series: [
          {
            name: "",
            type: "line",
            data: this.lineDataS,
            itemStyle: {
              color: "#333333",
            },
            lineStyle: {
              width: 1,
            },
          },
        ],
        toolbox: {
          show: true,
          feature: {
            myTool: {
              //自定义方法 配置   我这是为了实现 饼图切换为柱状图
              show: true,
              title: "导出",
              itemSize: 30,
              icon:
                'path d="M433.1 129.1l-83.9-83.9C342.3 38.32 327.1 32 316.1 32H64C28.65 32 0 60.65 0 96v320c0 35.35 28.65 64 64 64h320c35.35 0 64-28.65 64-64V163.9C448 152.9 441.7 137.7 433.1 129.1zM224 416c-35.34 0-64-28.66-64-64s28.66-64 64-64s64 28.66 64 64S259.3 416 224 416zM320 208C320 216.8 312.8 224 304 224h-224C71.16 224 64 216.8 64 208v-96C64 103.2 71.16 96 80 96h224C312.8 96 320 103.2 320 112V208z',
              onclick: function() {
                that.$emit("change", that.type);
              },
            },
          },
          right: 50,
          top: 36,
        },
      });
      myChart.resize();
    },
  },
};
</script>
<style>
.bx-export-header {
  z-index: -1;
}
</style>
